import {Component, HostBinding} from '@angular/core';
import { CmsAppTemplateSettingsService, SETTINGS_TYPES } from '../shared/app-template-settings.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CmsNotificationsService } from '../../core/notifications.service';
import { CmsNotifyService } from '../../core/notify.service';
import { CmsAppTemplatesService, AppTemplate } from '../../app-templates/shared/app-templates.service';
import { CmsTranslateService } from '../../shared/translate.service';
import { KeyValidationPattern } from '../../shared/common.service';
import { sortBy } from 'lodash';
import {validateJson} from '../../shared/json-editor/json-validator.directive';

@Component({
    selector: 'cms-new-app-template-setting',
    templateUrl: 'new-app-template-setting.component.html',
    providers: [CmsAppTemplateSettingsService]
})
export class CmsAppTemplateSettingsNewComponent {
    @HostBinding('class') classes = 'popup-overlay';
    form: FormGroup;
    settingTypes = SETTINGS_TYPES;
    appTemplates: Array<AppTemplate>;
    keyValidationInterpolationParams;
    private valueValidators = [Validators.required];

    constructor(
        private router: Router,
        private appTemplateSettingsService: CmsAppTemplateSettingsService,
        private fb: FormBuilder,
        private notificationsService: CmsNotificationsService,
        private notifyService: CmsNotifyService,
        private appTemplateService: CmsAppTemplatesService,
        private translateService: CmsTranslateService
    ) {
        this.form = this.fb.group({
            appTemplate: ['', [Validators.required]],
            key: ['', [Validators.required, Validators.maxLength(80), Validators.pattern(KeyValidationPattern.pattern)]],
            value: ['', this.valueValidators],
            type: ['', [Validators.required]]
        });

        this.keyValidationInterpolationParams = {
            field: this.translateService.translate('common_key').toLowerCase(),
            maximum: '80',
            characters: KeyValidationPattern.description
        };

        this.appTemplateService.getAppTemplates({pageSize: 100000}).subscribe(
            (data) => {
                if (data.appTemplates && data.appTemplates.length) {
                    this.appTemplates = sortBy(data.appTemplates, 'title');
                }
            }
        );
    }

    onSelectChanged(value: any) {
        if (value) {
            if (value.id === 'object' || value.id === 'config') {
                this.form.controls['value'].setValidators(Validators.compose([...this.valueValidators, validateJson]));
            } else {
                this.form.controls['value'].setValidators(this.valueValidators);
            }
        }

        this.form.controls['value'].markAsTouched();
        this.form.controls['value'].markAsDirty({onlySelf: true});
        this.form.controls['value'].updateValueAndValidity();
    }

    onSubmit(form: FormGroup) {
        this.appTemplateSettingsService.createAppTemplateSetting({
            appTemplate: form.value.appTemplate.id,
            key: form.value.key,
            value: form.value.value,
            type: form.value.type.id
        }).subscribe(
            res => {
                this.notificationsService.show({
                    type: 'action',
                    content: this.translateService.translate('settings_create_setting_success')
                });
                this.closePopup().then( () => {
                    this.notifyService.notify('appTemplateSettingNew');
                });
            },
            error => {
                this.notificationsService.show({
                    type: 'error',
                    content: error.message
                });
            }
        );
    }

    closePopup() {
        return this.router.navigate(
            [{outlets: {popup: null}}],
            {queryParamsHandling: 'preserve'}
        );
    }
}
